'use strict';

var _setup = require('./setup.js');

var _menuOverlay = require('./menu-overlay.js');

var $modalContent = _setup.s.$acctModal.find('.nx-acctembed');
var $embedParent = _setup.s.$acctModal.find('[data-login-url]');

var isLoggedIn = _setup.s.$body.hasClass('customer-logged-in');

var $iframe = null;
var frameWindow = null;
var iframeEmbedded = false;

// acct modal open
var openAccountModal = function openAccountModal(e) {
  e.preventDefault();

  if (isLoggedIn) {
    window.location.replace(window.magtheme.home + '/account');
    return false;
  }

  if (_setup._s.menuOverlayShowing) {
    _setup.s.$navModalToggle.trigger('click');
  }
  if (!iframeEmbedded) {
    $embedParent.html('<iframe id="nx-acct-iframe" src="' + $embedParent.data('login-url') + '" frameborder="0"></iframe>');
    $iframe = $embedParent.find('#nx-acct-iframe');
    frameWindow = $iframe[0].contentWindow;
    iframeEmbedded = true;
  }

  _setup.s.$body.addClass('is-showing-acctmodal');
  var $circle = (0, _menuOverlay.getCircularShape)().addClass('is-right-anchored is-above-header');
  _setup.s.$body.append($circle);

  //circle swipe
  TweenMax.set($circle, { x: '80%', y: '-80%', autoAlpha: 0 });
  TweenMax.to($circle, 0.7, { x: '20%', y: '-20%', autoAlpha: 1, ease: Power4.easeOut, onComplete: function onComplete() {
      $circle.remove();
    } });

  TweenMax.set($modalContent, { y: '100%', autoAlpha: 0 });
  TweenMax.to(_setup.s.$acctModal, 0.15, { autoAlpha: 1, delay: 0.4 });
  TweenMax.to($modalContent, 0.7, { y: '0%', scale: 1, autoAlpha: 1, delay: 0.4, ease: Expo.easeOut });
};

//acct modal close
var closeAccountModal = function closeAccountModal() {
  _setup.s.$body.removeClass('is-showing-acctmodal');
  TweenMax.to(_setup.s.$acctModal, 0.15, { autoAlpha: 0 });
};

if (_setup.s.$acctModal.length > 0) {
  _setup.s.$acctModalToggle.on('click', function (e) {
    return openAccountModal(e);
  });
  _setup.s.$acctModalClose.on('click', function () {
    return closeAccountModal();
  });
}

// iframe communication
var parentWindow = window.parent.window;
var viewingViaIframe = parentWindow.location.href !== window.location.href;

if (viewingViaIframe) {
  _setup.s.$body.addClass('is-viewing-via-iframe');
  var $acctToggle = $('.nx-acctpage--reverseaction a');

  _setup.s.$doc.ready(function () {
    return parentWindow.postMessage(_setup.s.$doc.height(), window.magtheme.home);
  });

  $acctToggle.click(function (e) {
    e.preventDefault();
    parentWindow.postMessage('reset', window.magtheme.home);
    window.location.replace($acctToggle.attr('href'));
  });
} else {

  //jquery no support postmessage
  var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
  var eventer = window[eventMethod];
  var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

  eventer(messageEvent, function (e) {
    if (e.data === 'reset') {
      TweenMax.to($embedParent, 0.2, { height: '32em' });
    } else {
      TweenMax.to($embedParent, 0.2, { height: e.data, ease: Expo.easeOut });
    }
  });
}

//auth-only account pages

if (_setup.s.isLoggedIn) {

  // const $orderHistory = $('#nx-acct-orderhistory');
  // const $orderRow = $orderHistory.find('tbody tr');

  // $orderRow.on('click', function(e) {
  //   const $a = $(this).find('a');
  //   console.log($a);
  //   $a.trigger('click');
  // });

  // //propagation causes infinite callstack
  // $orderRow.find('a').on('click', e => e.stopPropagation());
}


//////////////////
// WEBPACK FOOTER
// ./_js/account.js
// module id = 20
// module chunks = 0